if (!customElements.get('ofiyaa-new-collections')) {
  class OfiyaaNewCollections extends HTMLElement {
    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('[data-pill-index]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel-index]'));
      this.prevButton = this.querySelector('[data-nav="prev"]');
      this.nextButton = this.querySelector('[data-nav="next"]');
      this.viewAllLink = this.querySelector('[data-view-all-link]');
      this.activeIndex = 0;

      this.pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          this.activatePanel(Number(pill.dataset.pillIndex));
        });
      });

      this.panels.forEach((panel) => {
        const track = panel.querySelector('[data-carousel-track]');
        if (!track) return;

        track.addEventListener('scroll', () => this.updateNav(), { passive: true });
        track.addEventListener('scrollend', () => this.updateNav(), { passive: true });
      });

      this.prevButton?.addEventListener('click', () => this.scrollBy(1));
      this.nextButton?.addEventListener('click', () => this.scrollBy(-1));

      this.activatePanel(0);
    }

    activatePanel(index) {
      if (!this.panels[index]) return;

      this.activeIndex = index;

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.pills.forEach((pill, pillIndex) => {
        const isActive = pillIndex === index;
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      const track = this.getActiveTrack();
      if (track) {
        track.scrollLeft = 0;
      }

      window.requestAnimationFrame(() => this.updateNav());
      this.updateViewAllLink();
    }

    updateViewAllLink() {
      const panel = this.panels[this.activeIndex];
      if (!this.viewAllLink || !panel?.dataset.collectionUrl) return;
      this.viewAllLink.href = panel.dataset.collectionUrl;
    }

    getActiveTrack() {
      return this.panels[this.activeIndex]?.querySelector('[data-carousel-track]') || null;
    }

    scrollBy(direction) {
      const track = this.getActiveTrack();
      if (!track) return;

      const slide = track.querySelector('[data-carousel-slide]');
      if (!slide || !slide.offsetWidth) return;

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

      track.scrollBy({
        left: direction * (slide.offsetWidth + gap),
        behavior: 'smooth',
      });
    }

    updateNav() {
      const track = this.getActiveTrack();
      if (!track || !this.prevButton || !this.nextButton) return;

      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      const scrollOffset = Math.round(Math.abs(track.scrollLeft));
      const tolerance = 4;

      if (maxScroll <= tolerance) {
        this.prevButton.disabled = true;
        this.nextButton.disabled = true;
        return;
      }

      const atStart = scrollOffset <= tolerance;
      const atEnd = maxScroll < scrollOffset + tolerance;

      this.prevButton.disabled = atStart;
      this.nextButton.disabled = atEnd;
    }
  }

  customElements.define('ofiyaa-new-collections', OfiyaaNewCollections);
}
